var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { REWARDS_BULK_UPLOAD_FORM_MODAL_MODULE_ID, REWARDS_BULK_UPLOAD_FORM_MODULE_ID, } from 'root/src/shared/descriptions/modules/moduleIds';
import { z } from 'zod';
import displayModal from 'root/src/client/logic/modal/actions/displayModal';
import { parse } from 'csv-parse/browser/esm/sync';
const TEMPLATE_FIELD_MAPPING = {
    'Display Name': 'displayName',
    'Key/Code': 'type',
    'Video Game': 'gameName',
    'Key Type': 'keyType',
    Platform: 'platform',
    Region: 'region',
    'Key/Code Value': 'value',
    Url: 'url',
    Restrictions: 'restrictions',
};
const keySchema = z.object({
    type: z.literal('Key'),
    gameName: z.string(),
    keyType: z.string(),
    platform: z.string(),
    region: z.string(),
    value: z.string(),
    restrictions: z.string().optional(),
});
const codeSchema = z.object({
    type: z.literal('Code'),
    value: z.string(),
    restrictions: z.string().optional(),
    displayName: z.string(),
    url: z.string().optional(),
});
const itemSchema = z.discriminatedUnion('type', [
    keySchema,
    codeSchema,
]);
function getTemplateFileJSON(template) {
    const items = parse(template, {
        columns: true,
        trim: true,
        rtrim: true,
        cast: true,
        skip_empty_lines: true,
    });
    return items.map((item) => {
        return Object.entries(item)
            .reduce((acc, [key, value]) => {
            const mappedKey = TEMPLATE_FIELD_MAPPING[key];
            if (!mappedKey) {
                return acc;
            }
            return Object.assign(Object.assign({}, acc), { [mappedKey]: value });
        }, {});
    });
}
function processFile(file) {
    return __awaiter(this, void 0, void 0, function* () {
        const reader = new FileReader();
        reader.readAsText(file);
        return new Promise((resolve, reject) => {
            reader.onload = () => {
                resolve(reader.result);
            };
            reader.onerror = reject;
        });
    });
}
export const rewardsBulkUploadForm = {
    [REWARDS_BULK_UPLOAD_FORM_MODULE_ID]: [
        {
            action: (formData) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
                const { file } = formData.templateFile;
                const res = yield processFile(file);
                const templateJSON = getTemplateFileJSON(res);
                const data = templateJSON.map((item) => {
                    try {
                        return itemSchema.parse(item);
                    }
                    catch (err) {
                        console.error(err);
                        throw new Error("File is corrupted or doesn't match the template", { cause: { item, err } });
                    }
                });
                dispatch(displayModal(REWARDS_BULK_UPLOAD_FORM_MODAL_MODULE_ID, {
                    items: data,
                    isHeadless: true,
                }));
            }),
        },
    ],
};
